import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  res: [],
};

export const resSlice = createSlice({
  name: "res",
  initialState,
  reducers: {
    setRes: (state, action) => {
      state.res = action.payload;
    },
  },
});

export const { setRes } = resSlice.actions;

export default resSlice.reducer;
